
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiArrowBottomLeft as ObiArrowBottomLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-arrow-bottom-left.js';
 
 
 

 
 export const ObiArrowBottomLeft = createComponent({
   react: React,
   tagName: 'obi-arrow-bottom-left',
   elementClass: ObiArrowBottomLeftElement,
   events: {
     
   }
  });
 
 